import request from "../utils/request";

export function manualWalletLookup(telephone) {
  return request.get("Wallet/manual-lookup", {
    params: { telephone }
  });
}

export function manualWalletTransactions(customerId, pageIndex = 1, pageSize = 10) {
  return request.get("Wallet/manual-transactions", {
    params: { customerId, pageIndex, pageSize }
  });
}

/** FormData: customerId, amount, note, file */
export function manualWalletTopup(formData) {
  return request.post("Wallet/manual-topup", formData);
}

/** FormData: customerId, amount, note, file */
export function manualWalletDeduct(formData) {
  return request.post("Wallet/manual-deduct", formData);
}
